<template>
  <div :class="['zhaogu-page', isPersonalCenter ? '' : 'w1200']">
    <div class="page-bar">
      <span class="back-btn" @click="goBack">← 返回</span>
      <el-button type="primary" size="small" icon="el-icon-plus" class="publish-btn"
        @click="goPublish">发布众筹招股</el-button>
    </div>
    <div class="page-title">我发布的众筹招股</div>

    <el-table v-loading="loading" :data="list" empty-text="暂无发布的招股"
      :header-cell-style="{ 'textAlign': 'center' }" :cell-style="{ 'textAlign': 'center' }">
      <el-table-column type="index" label="序号" width="60"></el-table-column>
      <el-table-column prop="title" label="众筹标题" show-overflow-tooltip></el-table-column>
      <el-table-column prop="issueNumber" label="期号" width="110"></el-table-column>
      <el-table-column label="彩种" width="100">
        <template slot-scope="{ row }">{{ lotteryTypeName(row.lotteryType) }}</template>
      </el-table-column>
      <el-table-column label="众筹总额" width="120">
        <template slot-scope="{ row }">{{ money(row.crowdfundingAmount) }} 元</template>
      </el-table-column>
      <el-table-column label="每股价格" width="110">
        <template slot-scope="{ row }">{{ money(row.crowdfundingPrice) }} 缩币</template>
      </el-table-column>
      <el-table-column prop="totalShareNumber" label="总股数" width="90"></el-table-column>
      <el-table-column prop="subscribedShareNumber" label="已认购" width="90"></el-table-column>
      <el-table-column prop="remainingShareNumber" label="剩余" width="90"></el-table-column>
      <el-table-column label="进度" width="160">
        <template slot-scope="{ row }">
          <el-progress :percentage="progress(row)" :stroke-width="10"></el-progress>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="280" fixed="right">
        <template slot-scope="{ row }">
          <el-button type="text" @click="goDetail(row.crowdfundingId)">详情</el-button>
          <el-button type="text" @click="goUploadContract(row)">四件套</el-button>
          <el-button type="text" @click="goEquity(row.crowdfundingId)">股权清单</el-button>
          <el-button type="text" @click="openRemit(row)">派奖管理</el-button>
          <el-button type="text" @click="openClaim(row)">兑奖列表</el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="fenye" v-if="total > 0">
      <el-pagination background layout="prev, pager, next" :total="total"
        :page-size="pageSize" :current-page="pageNum" @current-change="onPage"></el-pagination>
    </div>

    <!-- 派奖管理 -->
    <el-dialog title="派奖管理（上传打款凭证）" :visible.sync="remitDialog" width="840px" @close="remitList = []">
      <div v-loading="remitLoading" style="min-height: 120px;">
        <el-alert type="info" :closable="false" title="对每位已认购散户逐一上传打款凭证；上传后该认购明细标记为已派奖。内部认购方免打款。"
          style="margin-bottom: 12px;"></el-alert>
        <el-table :data="remitList" empty-text="暂无认购人" v-if="remitList.length"
          :header-cell-style="{ 'textAlign': 'center' }" :cell-style="{ 'textAlign': 'center' }">
          <el-table-column prop="purchaser" label="认购人" show-overflow-tooltip></el-table-column>
          <el-table-column prop="purchaserNumber" label="认购股数" width="100"></el-table-column>
          <el-table-column label="每股分红" width="110">
            <template slot-scope="{ row }">{{ money(row.dividendAmount) }} 缩币</template>
          </el-table-column>
          <el-table-column prop="bonusStatusIntro" label="派奖状态" width="110"></el-table-column>
          <el-table-column label="打款凭证" width="90">
            <template slot-scope="{ row }">
              <el-image v-if="row.remit" :src="row.remit" style="width:54px;height:54px"
                :preview-src-list="[row.remit]" fit="cover"></el-image>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="140">
            <template slot-scope="{ row }">
              <el-upload v-if="row.bonusStatus !== '2'" accept="image/*" :auto-upload="false"
                :show-file-list="false" :on-change="(f) => onRemitChange(f, row)">
                <el-button size="small" type="primary" :loading="row._uploading">上传凭证</el-button>
              </el-upload>
              <span v-else style="color:#909399;">免打款</span>
            </template>
          </el-table-column>
        </el-table>
        <div v-else class="tip-msg">暂无认购人</div>
      </div>
    </el-dialog>

    <!-- 兑奖列表 -->
    <el-dialog title="兑奖列表（中奖认购明细）" :visible.sync="claimDialog" width="880px" @close="claimList = []">
      <div v-loading="claimLoading" style="min-height: 120px;">
        <el-table :data="claimList" empty-text="暂无中奖明细" v-if="claimList.length"
          :header-cell-style="{ 'textAlign': 'center' }" :cell-style="{ 'textAlign': 'center' }">
          <el-table-column prop="purchaser" label="认购人" show-overflow-tooltip></el-table-column>
          <el-table-column prop="purchaserNumber" label="认购股数" width="100"></el-table-column>
          <el-table-column label="税前中奖" width="120">
            <template slot-scope="{ row }">{{ money(row.beforeTaxAmount) }} 元</template>
          </el-table-column>
          <el-table-column label="税后中奖" width="120">
            <template slot-scope="{ row }">{{ money(row.afterTaxAmount) }} 元</template>
          </el-table-column>
          <el-table-column label="应付分红" width="120">
            <template slot-scope="{ row }">{{ money(row.payable) }} 缩币</template>
          </el-table-column>
          <el-table-column prop="bonusStatusIntro" label="派奖状态" width="110"></el-table-column>
        </el-table>
        <div v-else class="tip-msg">暂无中奖明细</div>
      </div>
      <div class="fenye" v-if="claimTotal > 0">
        <el-pagination background layout="prev, pager, next" :total="claimTotal"
          :page-size="claimPageSize" :current-page="claimPageNum" @current-change="onClaimPage"></el-pagination>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { bettingShopMyOfferingList, bettingShopClaimPrize, bettingShopRemitUpload } from "@/api/apply";
import { upLoadFile } from "@/api/common";

const LOTTERY_MAP = {
  '0': '双色球', '1': '大乐透', '2': '福彩3D', '3': '排列3',
  '5': '七乐彩', '6': '7星彩', '7': '排列5', '8': '快乐8',
};

export default {
  name: "MyOffering",
  data() {
    return {
      list: [],
      loading: false,
      total: 0,
      pageSize: 10,
      pageNum: 1,

      // 派奖管理
      remitDialog: false,
      remitLoading: false,
      remitList: [],
      // 兑奖列表
      claimDialog: false,
      claimLoading: false,
      claimList: [],
      claimTotal: 0,
      claimPageSize: 10,
      claimPageNum: 1,
      claimQuery: null,
    };
  },
  computed: {
    isPersonalCenter() {
      return this.$route.path.startsWith('/personalCenter');
    }
  },
  mounted() {
    this.loadList();
  },
  methods: {
    goBack() {
      if (this.isPersonalCenter) {
        this.$router.push('/personalCenter');
      } else {
        this.$router.push("/sttzzbfzx/zhaogu");
      }
    },
    goPublish() {
      this.$router.push("/personalCenter/tzz_bf/ManagerApply");
    },
    goDetail(id) {
      this.$router.push("/sttzzbfzx/zhaogu/detail/" + id);
    },
    goUploadContract(row) {
      this.$router.push({
        path: "/sttzzbfzx/contract/upload/" + row.crowdfundingId,
        query: {
          title: row.title || "",
          issueNumber: row.issueNumber || "",
          lotteryType: row.lotteryType || "",
          bettingShopAddress: row.bettingShopAddress || "",
          bettingShopNumber: row.bettingShopNumber || "",
        },
      });
    },
    goEquity(id) {
      this.$router.push("/sttzzbfzx/equity/" + id);
    },
    lotteryTypeName(type) {
      return LOTTERY_MAP[type] || type || "-";
    },
    money(v) {
      if (v == null || v === "") return "-";
      const n = Number(v);
      return isNaN(n) ? v : n;
    },
    progress(row) {
      const p = Number(row && row.subscribeProgress || 0);
      return p > 100 ? 100 : p;
    },
    loadList() {
      this.loading = true;
      bettingShopMyOfferingList({ pageNum: this.pageNum, pageSize: this.pageSize })
        .then((res) => {
          const rows = (res && res.rows) || (res && res.data && res.data.rows) || [];
          const total = (res && res.total) || (res && res.data && res.data.total) || 0;
          this.list = rows;
          this.total = total;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    onPage(page) {
      this.pageNum = page;
      this.loadList();
    },

    // ===== 派奖管理 =====
    openRemit(row) {
      this.remitDialog = true;
      this.remitLoading = true;
      this.remitList = (row.purchaserList || []).map((p) => ({ ...p, _uploading: false }));
      this.remitLoading = false;
    },
    onRemitChange(file, row) {
      if (!file || !file.raw) return;
      const fd = new FormData();
      fd.append("file", file.raw);
      row._uploading = true;
      upLoadFile("/remit", fd)
        .then((res) => {
          const url = res && res.data && res.data.urls;
          if (!url) {
            this.$message.error("凭证上传失败");
            row._uploading = false;
            return;
          }
          bettingShopRemitUpload({ detailId: row.detailId, remit: url })
            .then((r) => {
              if (r && r.code === 200) {
                this.$message.success("已上传打款凭证");
                row.remit = url;
                row.bonusStatus = "1";
                row.bonusStatusIntro = "已派奖";
              } else {
                this.$message.error((r && r.msg) || "上传打款凭证失败");
              }
              row._uploading = false;
            })
            .catch(() => { row._uploading = false; });
        })
        .catch(() => { row._uploading = false; });
    },

    // ===== 兑奖列表 =====
    openClaim(row) {
      this.claimQuery = { issueNumber: row.issueNumber, lotteryType: row.lotteryType };
      this.claimPageNum = 1;
      this.claimDialog = true;
      this.loadClaim();
    },
    loadClaim() {
      if (!this.claimQuery) return;
      this.claimLoading = true;
      bettingShopClaimPrize({
        ...this.claimQuery,
        pageNum: this.claimPageNum,
        pageSize: this.claimPageSize,
      })
        .then((res) => {
          this.claimList = (res && res.rows) || (res && res.data && res.data.rows) || [];
          this.claimTotal = (res && res.total) || (res && res.data && res.data.total) || 0;
          this.claimLoading = false;
        })
        .catch(() => { this.claimLoading = false; });
    },
    onClaimPage(page) {
      this.claimPageNum = page;
      this.loadClaim();
    },
  },
};
</script>

<style lang="scss" scoped>
.zhaogu-page {
  background: #ffffff;
  padding: 20px;
  margin-top: 20px;
  margin-bottom: 20px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
  border-radius: 8px;

  .page-bar {
    margin-bottom: 10px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .publish-btn {
    margin-left: auto;
  }

  .back-btn {
    display: inline-block;
    cursor: pointer;
    color: #347caf;
    font-size: 14px;
    padding: 6px 14px;
    border: 1px solid #347caf;
    border-radius: 5px;
    transition: all 0.2s;

    &:hover {
      background-color: #347caf;
      color: #ffffff;
    }
  }

  .page-title {
    font-size: 22px;
    font-weight: bold;
    color: #347caf;
    text-align: center;
    padding: 10px 0 20px;
    border-bottom: 2px solid #347caf;
    margin-bottom: 20px;
  }
}

.fenye {
  margin-top: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.tip-msg {
  color: #898af7;
  font-weight: bold;
  padding: 14px 0;
  text-align: center;
}

.qr-box {
  text-align: center;

  .qr-big {
    width: 200px;
    height: 200px;
    object-fit: contain;
  }

  .qr-tip {
    margin-top: 10px;
    font-size: 12px;
    color: #888;
  }
}
</style>
